import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.span`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(12)};
  width: 100%;
`;

const KeyLabel = styled.span`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${rem(14)};
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  line-height: ${rem(16)};
  white-space: nowrap;
`;

const Item = styled.span`
  align-items: center;
  display: inline-flex;
  gap: ${rem(8)};
`;

const ItemDot = styled.span<{ color: string }>`
  background: ${({ color, theme }) => color ?? theme.palette.grey['500']};
  border-radius: 50%;
  display: inline-block;
  flex: 0 0 auto;
  height: ${rem(10)};
  width: ${rem(10)};
`;

const ItemLabel = styled.span`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${rem(12)};
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  line-height: ${rem(16)};
  white-space: nowrap;
`;

export default {
  Wrapper,
  KeyLabel,
  Item,
  ItemDot,
  ItemLabel
};
